export default "__VITE_ASSET__DdrT7pQn__"